import { Link, useNavigate } from "react-router-dom";
import {UiRadiosGrid, Briefcase, Boxes, Gear, PlusCircle} from "react-bootstrap-icons";
import { navigateAdvisory } from "../util/utils";

export function BottomMenu(props) {
	let navigate = useNavigate();

    return (<div className="bottomNav">
        <div className="navItem">
            <a className="link" onClick={() => navigateAdvisory(navigate, "/dashboard")}>
            	<UiRadiosGrid className="navIcon"/>
				<br />
				<span className="linkText">Home</span>
			</a>
        </div>

        <div className="navItem">
			<a className="link" onClick={() => navigateAdvisory(navigate, "/assets")}>
            	<Briefcase className="navIcon"/>
				<br />
				<span className="linkText">Assets</span>
			</a>
        </div>

        <div className="navItem bottomInspect">
			<a className="link" onClick={() => navigateAdvisory(navigate, "/inspections/begin")}>
	            <PlusCircle className="navIconInspection"/>
			</a>
        </div>
        
        <div className="navItem">
			<a className="link" onClick={() => navigateAdvisory(navigate, "/jobs")}>
				<Boxes className="navIcon"/>
				<br />
				<span className="linkText">Jobs</span>
			</a>
        </div>

        <div className="navItem">
			<a className="link" onClick={() => navigateAdvisory(navigate, "/settings")}>
				<Gear className="navIcon"/>
				<br />
				<span className="linkText">Settings</span>
			</a>
        </div>
    </div>)
}
